var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.966 30.3036H13.8179C13.5506 30.3123 13.2907 30.2147 13.0952 30.0322C12.8997 29.8496 12.7846 29.5971 12.7749 29.3298V12.9939C12.788 12.73 12.9051 12.4819 13.1005 12.304C13.2959 12.1261 13.5538 12.0328 13.8179 12.0444H32.1822C32.4463 12.0328 32.7042 12.1261 32.8996 12.304C33.095 12.4819 33.2121 12.73 33.2252 12.9939V29.3298C33.2155 29.5971 33.1004 29.8496 32.9049 30.0322C32.7094 30.2147 32.4495 30.3123 32.1822 30.3036H31.0341",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4268 15.6963H29.5734",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3947 19.3481H25.9216",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5223 28.4778C17.5223 29.9305 18.0995 31.3238 19.1267 32.3511C20.154 33.3784 21.5473 33.9555 23.0001 33.9555C24.4529 33.9555 25.8462 33.3784 26.8735 32.3511C27.9007 31.3238 28.4779 29.9305 28.4779 28.4778C28.4779 27.025 27.9007 25.6317 26.8735 24.6044C25.8462 23.5771 24.4529 23 23.0001 23C21.5473 23 20.154 23.5771 19.1267 24.6044C18.0995 25.6317 17.5223 27.025 17.5223 28.4778V28.4778Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1999 27.0254L22.8257 30.1913C22.7729 30.2614 22.7057 30.3194 22.6286 30.3614C22.5515 30.4034 22.4663 30.4284 22.3787 30.4346C22.2912 30.4409 22.2033 30.4284 22.1209 30.3978C22.0386 30.3672 21.9638 30.3194 21.9016 30.2575L20.6736 29.0295",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallout);
export default __webpack_public_path__ + "static/media/Callout.698bb8a6434f1b71b1782fef106753cc.svg";
export { ForwardRef as ReactComponent };